import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo Moauth 產生 url
 */
const MOauthGenerate = [
    'POST',
    RouteUrlList.API_MOauthGenerate.path,
    {},
    200,
    {
        url: 'https://mobile.esunbank.com.tw/Mobile/MobileOAuth/?Token=mz4A80jbeT%2fDk0fM8Dw1TigAfvVGMLsXFjWCkLp3Lec0fuHG4pCIBZdrwtZ3qyik7vorQoHnGOzbAkHg4ZiQID2j1qmYiWYlmFDIIBtrF3V%2fLKkJdp0%2fHMVFSpZfLRj1isgPzJIz%2fZmchW8l43yYy2mBBvH0WwNAQnf3LXLhCK%2bXiEzJmhfpej%2f%2bKOgCjq1IHbsMDnfxwT5n5UlPXMsX0Q%3d%3d',

        status: true,
        title: null,
        message: null,
        errorCode: null
    }
];
export default MOauthGenerate;
